export default "__VITE_ASSET__Cr0Y6SdX__"